import type { DeepRequired } from '../fixtures.types'

const productCommission: DeepRequired<ProductCommission> = {
  __typename: 'ProductCommission',
  commission_frequency: null,
  description: null,
  initial_commission: null,
  initial_commission_end_date: null,
  renewal_commission: null,
  renewal_commission_end_date: null,
  renewal_commission_frequency: null,
  renewal_commission_start_date: null,
}

export default productCommission
